import React from "react";
import RevealAnimation from "../RevealAnimation";
import ModernArticleCard from "./ModernArticleCard";
import "./articlesGridSection.scss";

function ArticlesGridSection({
  articles = [],
  hasMore = false,
  onLoadMore,
  isLoading = false,
  contentLabel = "Articles",
  emptyTitle = "No articles found",
  emptyDescription = "Try adjusting your filters or check back later for new content.",
}) {
  if (!articles || articles.length === 0) {
    return (
      <section className="articles-grid-section body-container">
        <div className="articles-empty-state">
          <div className="empty-icon">
            <svg
              width="64"
              height="64"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
          </div>
          <h3>{emptyTitle}</h3>
          <p>{emptyDescription}</p>
        </div>
      </section>
    );
  }

  const featuredArticle = articles[0];
  const remainingArticles = articles.slice(1);

  return (
    <section className="articles-grid-section">
      {/* Featured Article */}
      <div className="body-container">
        <RevealAnimation animation="fade" delay={0.1}>
          <div className="featured-article-wrapper">
            <ModernArticleCard article={featuredArticle} featured />
          </div>
        </RevealAnimation>
      </div>

      {/* Articles Grid */}
      {remainingArticles.length > 0 && (
        <div className="body-container">
          <div className="articles-grid-header">
            <RevealAnimation animation="slide-left" delay={0.1}>
              <h2 className="grid-title">
                Latest <span className="title-accent">{contentLabel}</span>
              </h2>
            </RevealAnimation>
            <RevealAnimation animation="slide-right" delay={0.15}>
              <p className="grid-subtitle">
                {articles.length} {contentLabel.toLowerCase()} available
              </p>
            </RevealAnimation>
          </div>

          <div className="articles-grid">
            {remainingArticles.map((article, index) => (
              <ModernArticleCard
                key={article.slug || index}
                article={article}
                index={index}
              />
            ))}
          </div>
        </div>
      )}

      {/* Load More */}
      {hasMore && (
        <div className="load-more-wrapper">
          <button
            className={`load-more-btn ${isLoading ? "loading" : ""}`}
            onClick={onLoadMore}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="load-spinner" />
                Loading...
              </>
            ) : (
              <>
                Load More {contentLabel}
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </>
            )}
          </button>
        </div>
      )}
    </section>
  );
}

export default ArticlesGridSection;
